import { getItem } from "../services/localStorageService";
import { LOCAL_STORAGE_KEYS } from "../consts/constants";

export default function getAccessToken() {
  return getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN) || "";
}
